import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { IGlimpseUser } from 'src/app/modules/auth/models/IGlimpseUser';
import * as fromStore from "../../../../auditing-components/store/tasks";
import { Store } from "@ngrx/store";
import { AuthState } from "../../../../../store/auth";
import { ThemeMode, ThemeService } from "../../../../shared/services/theme.service";

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserMenuComponent implements OnInit {
  @Input() user: IGlimpseUser;
  @Input() isAdmin: boolean;
  @Input() isInAdmin: boolean;
  @Input() isInAuditing: boolean;
  @Output() logout = new EventEmitter();

  themes: { mode: ThemeMode; label: string }[] = [
    { mode: 'light', label: 'Light' },
    { mode: 'dark', label: 'Dark' },
    { mode: 'system', label: 'System' },
  ];

  constructor(private store: Store<{ auth: AuthState }>, public themeService: ThemeService) {}

  ngOnInit() {}

  onLogout() {
    this.store.dispatch(fromStore.setIsAuditorReady({ isAuditorReady: false }));
    this.logout.emit();
  }
}
